module.exports = __webpack_public_path__ + "assets/img/4_1555.28185330.jpg";